import Router from './Router';

function App() {
	return (
		<div className='overflow-scroll'>
			<Router />
		</div>
	);
}

export default App;
